export default {
    LOGIN: (state, data) => {
        //更改token的值
        state.token = data;
        window.sessionStorage.setItem('token', data);
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js